// extracted by mini-css-extract-plugin
var _1 = "WXkLgUwUkNcwwF5UiLlB";
var _2 = "WXkLgUwUkNcwwF5UiLlB";
export { _1 as "no-padding", _2 as "noPadding" }
